module.exports = __webpack_public_path__ + "img/trend-after-1.55558728.png";